<template>
  <FormShell :pill="$t('pill')" :card="false">
    <template #body>
      <p class="variant-intro__title">{{ $t('title') }}</p>
    </template>

    <template #footer>
      <div class="variant-bottom-bar__row">
        <div class="variant-bottom-bar__action">
          <t-btn-link
            id="footerNextButton"
            class="variant-bottom-bar__next"
            to="/v2/offertes-aanvragen/type-opdracht"
          >
            {{ $t('nextBtn') }}
          </t-btn-link>

          <p class="variant-bottom-bar__subtext">{{ $t('subtext') }}</p>
        </div>
      </div>
    </template>
  </FormShell>
</template>

<script>
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import FormShell from '~/components/form/FormShell.PD-10913'
import VariantGuard from '~/middleware/VariantGuard.PD-10913'

export default {
  components: {
    FormShell,
  },

  extends: AbstractFormPage,

  layout: 'variant.PD-10913',

  middleware: [VariantGuard], // PD-10913: shadows FlowGuard.

  /**
   * @returns {object}
   */
  data() {
    return {
      path: '/v2/offertes-aanvragen/start',
      progressValue: 0,
      checkoutStep: 1,
    }
  },

  /**
   * Set translated head meta from i18n.
   */
  created() {
    this.headTitle = this.$t('headTitle')
    this.headDescription = this.$t('headDescription')
  },

  /**
   * No form step on this page, so push the progress value ourselves.
   */
  mounted() {
    this.$store.dispatch('progressbar/add', {
      key: 'progress',
      value: this.progressValue,
    })
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "headTitle": "Start vragenlijst",
    "headDescription": "We gaan je nu een paar vragen stellen. Hierdoor kunnen we makelaars vinden die bij jou passen.",
    "pill": "Makelaars vergelijken in 1 minuut",
    "title": "We gaan je nu een paar vragen stellen. Hierdoor kunnen we makelaars vinden die bij jou passen.",
    "nextBtn": "Ga verder",
    "subtext": "Gratis & volledig vrijblijvend"
  }
}
</i18n>
